export class Partner {
    constructor(
        public id: number,
        public name: string,
        public technicalName: string,
        public url: string,
        public order: number,
        public version: number,
        public deleted: boolean,
        public picturePath: string,
        public publishedUnlisted: boolean = false
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/_services/partner/partner.model.ts